import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { CssBaseline, AppBar, Toolbar, Button } from "@mui/material";
import { Lock, Mail } from "react-feather";
import { Link } from "react-router-dom";
import SpiffyLogo from "../assets/images/newspiffy.avif";
import useGlobalStore from "src/store/useGlobalStore";
import { Redirect } from "react-router-dom";
import { PATHS } from "src/routes";

const APP_BAR_HEIGHT = 80;

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }
  body {
    background: ${(props) => props.theme.palette.background.default};
  }
`;

const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
`;

const AuthAppBar = styled(AppBar)`
  height: ${APP_BAR_HEIGHT}px;
  display: flex;
  justify-content: center;
  align-items: space-evenly;
  padding-left: ${(props) => props.theme.spacing(5)};
  padding-right: ${(props) => props.theme.spacing(5)};
  background-color: ${(props) => props.theme.sidebar.background};
`;

const LogoImage = styled.img`
  height: 36px;
  width: auto;

  @media (max-width: 500px) {
    height: 26px;
  }
`;

const LinkBox = styled.div`
  margin-left: auto;
  width: 260px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 500px) {
    width: 180px;
  }
`;

const AppBarLink = styled(Button)`
  text-decoration: none;
  color: ${(props) => props.theme.palette.primary.contrastText};
  white-space: nowrap;
  margin-left: 20px;
  font-size: 16px;
  background-color: transparent;

  @media (max-width: 500px) {
    font-size: 12px;
    margin-left: 8px;
  }

  &:hover {
    color: ${(props) => props.theme.palette.primary.light};
  }
`;

const MainWrapper = styled.div`
  width: 100%;
  flex: 1 1 0%;
  min-height: 0;
  overflow-y: auto; // Use overflow-y: auto for vertical scrolling
`;

const AuthLayout = ({ children }) => {
  const isAuthenticated = useGlobalStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Redirect to={PATHS.HOME} />;
  }

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <AuthAppBar position="sticky" elevation={0}>
        <Toolbar>
          <LogoImage src={SpiffyLogo} alt="" />
          <LinkBox>
            <AppBarLink component={Link} to="/" startIcon={<Lock />}>
              Log In
            </AppBarLink>
            <AppBarLink component={Link} to="/contact" startIcon={<Mail />}>
              Contact Us
            </AppBarLink>
          </LinkBox>
        </Toolbar>
      </AuthAppBar>
      <MainWrapper>{children}</MainWrapper>
    </Root>
  );
};

export default AuthLayout;
